export class SolicitarInstituicao
{
    instituicaoId: string;
    diretoInstituicao: boolean;
    dadosContaInstituicao: DadosContaInstituicao
    pagamentoOnline: PagamentoOnline
  }
export class DadosContaInstituicao{
  tipoConta: string;
  agencia: string;
  conta: string;
  digitoConta: string
};

export class SolicitarCorretora{
  pelaCorretora: boolean;
  dadosCorretora: DadosCorretora;
  pagamentoOnline: PagamentoOnline
}

export class DadosCorretora{
    idCorretora: string
}

export class PagamentoOnline{
  pagamentoOnline: boolean;
  dadosPagamentoOnline: DadosPagamentoOnline
}
export class DadosPagamentoOnline {
  tipoConta: string;
  agencia: string;
  bancoId: string;
  conta: string;
  digitoConta: string
  digitoAgencia: string
}
export class SolicitarAmbos{
  instituicaoId: string;
  diretoInstituicao: boolean;
  dadosContaInstituicao: DadosContaInstituicao
  pelaCorretora: boolean;
  dadosCorretora: {
    idCorretora: string
  }
  pagamentoOnline: PagamentoOnline
}
